<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <h2>操作日志</h2>
      <p>所有配置、确认、作废、结账和反结账操作均可追溯</p>
    </div>
    <el-card shadow="never">
      <el-form inline>
        <el-form-item label="动作">
          <el-select
            v-model="action"
            clearable
            @change="load"
          >
            <el-option
              v-for="a in actions"
              :key="a"
              :label="a"
              :value="a"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="rows"
        v-loading="loading"
      >
        <el-table-column
          prop="created_at"
          label="时间"
          width="180"
        />
        <el-table-column
          prop="user_name"
          label="管理员"
        />
        <el-table-column
          prop="action"
          label="动作"
        />
        <el-table-column
          prop="biz_type"
          label="业务类型"
        />
        <el-table-column
          prop="biz_id"
          label="业务ID"
        />
        <el-table-column
          prop="reason"
          label="原因"
        />
        <el-table-column
          label="变更详情"
          width="100"
        >
          <template #default="{ row }">
            <el-popover
              width="500"
              trigger="click"
            >
              <template #reference>
                <el-button
                  link
                  type="primary"
                >
                  查看
                </el-button>
              </template>
              <p>原值：{{ row.before_value || '-' }}</p>
              <p>新值：{{ row.after_value || '-' }}</p>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { organizationApi } from '../api'
const rows = ref([]),
  loading = ref(false),
  action = ref(''),
  actions = [
    'CREATE',
    'UPDATE',
    'CONFIRM',
    'VOID',
    'CLOSE',
    'REOPEN',
    'COMPLETE',
    'LOGIN',
    'LOGOUT',
  ]
const load = async () => {
  loading.value = true
  try {
    rows.value = (await organizationApi.logs({ action: action.value })) || []
  } finally {
    loading.value = false
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
